var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlledTierBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "27px",
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Controlled Tier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Controlled-user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CT---Share",
    transform: "translate(-399.000000, -492.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(376.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Controlled-tier",
    transform: "translate(24.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6171765,24.8170261 C16.8016987,23.0738567 23.4374441,17.0533727 23.4374441,6.24774397 C23.4374441,5.30046153 22.8661469,4.44597138 21.9970179,4.08467273 L12.6220402,0.178432039 C12.3449508,0.0634668744 12.0411586,0 11.7227275,0 C11.4042487,0 11.0974047,0.0634668744 10.8202676,0.178432039 L1.44528998,4.08467273 C0.571297237,4.44597138 0,5.30046153 0,6.24774397 C0,15.9401037 5.59080698,22.639316 10.8154039,24.8170261 C11.3915649,25.0563024 12.0409678,25.0563024 12.6171765,24.8170261 Z",
    id: "\\uF132",
    stroke: "#FFFFFF",
    fill: "#F7981C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24075186,16.0487067 C9.65975186,16.0487067 10.8037519,15.6637067 11.7387519,14.5197067 L10.2097519,13.0567067 C9.68175186,13.6947067 9.09875186,13.9477067 8.49375186,13.9477067 C7.53675186,13.9477067 6.90975186,13.3427067 6.90975186,12.4407067 C6.90975186,11.0657067 7.76775186,10.0977067 8.98875186,10.0977067 C9.69275186,10.0977067 10.1987519,10.4277067 10.5287519,10.9997067 L12.3987519,9.53670672 C11.8377519,8.54670672 10.6277519,7.99670672 9.15375186,7.99670672 C6.30475186,7.99670672 4.29175186,9.89970672 4.29175186,12.6057067 C4.29175186,14.6517067 5.85375186,16.0487067 8.24075186,16.0487067 Z M16.3147519,15.8727067 L17.4477519,10.1857067 L19.7027519,10.1857067 L20.1097519,8.17270672 L13.0037519,8.17270672 L12.5967519,10.1857067 L14.8517519,10.1857067 L13.7187519,15.8727067 L16.3147519,15.8727067 Z",
    id: "CT",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlledTierBadge);
export default __webpack_public_path__ + "static/media/controlled-tier-badge.674ec08a2f836b7a42b6f5fc42194a32.svg";
export { ForwardRef as ReactComponent };